import * as React from "react"
import * as styles from "./styles.module.scss"
import LogoTesla from "../../../logos/Tesla"
import LogoSolarMortgage from "../logo-solar-mortgage"
import teslaHeroVideo from "./video/tesla-hero.mp4"
import Button from "components/Button"

export interface HeroProps {
  hasTeslaLogo: boolean
}

const Hero: React.FC<HeroProps> = ({ hasTeslaLogo }) => {
  return (
    <section className={styles.hero} data-js-position="in-viewport">
      <video className={styles.video} autoPlay muted playsInline loop>
        <source src={teslaHeroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {hasTeslaLogo && (
        <picture className={styles.teslaLogo}>
          <p className={styles.teslaLogoEyebrow}>In partnership with</p>
          <LogoTesla />
        </picture>
      )}
      <div className={styles.pagePadding}>
        <div className={styles.logo}>
          <LogoSolarMortgage />
        </div>
        <div className={styles.messageWrapper}>
          <div className={styles.message}>
            <h3 className={styles.heading}>
              Let your <span className={styles.noWrap}>Solar Roof</span> pay for
              itself
            </h3>
          </div>
          <div className={styles.actions}>
            <Button
              type="primary"
              size="lg"
              halo={true}
              to="/start"
              target="_self"
            >
              Get started
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
